export default "<app-header></app-header>\n<main class=\"main\">\n  <router-outlet></router-outlet>\n</main>\n<app-footer></app-footer>";